/*
  Speed (Claude, 1 Nov 2026): stand-in for Slick on pages that have no Slick slider.
  The full Slick library (about 42 KB, plus two stylesheets from other CDNs) now loads only on pages
  whose content has a Slick slider (see layout/theme.liquid). Everywhere else this file provides
  $.fn.slick so that:
  - the announcement bar still shows and rotates its messages (fade, autoplay), and
  - theme-custom.js can still call .slick() on sliders that are not on the page without an error.
*/
(function ($) {
  if (!$ || $.fn.slick) return;
  $.fn.slick = function (opts) {
    if (!opts || typeof opts !== 'object') return this;
    return this.each(function () {
      var el = this;
      if (!el.classList.contains('announcement-slider') || el.classList.contains('slick-initialized')) return;
      var slides = Array.prototype.slice.call(el.children);
      el.classList.add('slick-initialized');
      if (!slides.length) return;
      slides[0].classList.add('slick-active');
      if (slides.length < 2 || !opts.autoplay) return;
      el.style.position = 'relative';
      slides.forEach(function (s, n) {
        if (n) { s.style.position = 'absolute'; s.style.top = '0'; s.style.left = '0'; s.style.right = '0'; }
        s.style.transition = 'opacity .5s ease';
      });
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('slick-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('slick-active');
      }, opts.autoplaySpeed || 3000);
    });
  };
})(window.jQuery);
